import {
  SystemAdminNotification,
  SystemNotification,
  TemplateNotification,
} from "../globalTypes";
import { notificationsConnection } from "../requests/signalRConnections";
import {
  receiveSystemNotifications,
  receiveTemplateNotifications,
} from "./notifications/actionCreators";
import { receiveSystemAdminNotifications } from "./notifications/systemAdmin/actionCreators";
import { parseNotifications } from "./notifications/utils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function register(dispatch: any) {
  notificationsConnection.on(
    "sendTemplateNotificationsToUser",
    (receivedNotifications: string[]) => {
      const payload = {
        notifications: parseNotifications<TemplateNotification>(
          receivedNotifications
        ),
      };
      dispatch(receiveTemplateNotifications(payload));
    }
  );

  notificationsConnection.on(
    "sendSystemNotificationsToUser",
    (receivedNotifications: string[]) => {
      const payload = {
        notifications: parseNotifications<SystemNotification>(
          receivedNotifications
        ),
      };
      dispatch(receiveSystemNotifications(payload));
    }
  );

  notificationsConnection.on(
    "sendSystemAdminNotificationsToUser",
    (receivedNotifications: string[]) => {
      const payload = {
        notifications: parseNotifications<SystemAdminNotification>(
          receivedNotifications
        ),
      };
      dispatch(receiveSystemAdminNotifications(payload));
    }
  );
}
